export default __webpack_public_path__ + "static/media/Soporte_Icon.ee194c18.svg";